import { agencyResource } from './../organizationalManage/request';
import { addReminder, editReminder } from './request';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false,
      agencyList: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('模版名称')
        }],
        agencyId: [{
          required: true,
          message: this.$t('请选择') + this.$t('所属机构'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('提醒内容')
        }]
      };
    }
  },
  methods: {
    init(data) {
      if (data.reminderId) {
        console.log(data);
        this.dataFrom = {
          reminderId: data.reminderId,
          name: data.name,
          agencyId: data.agencyId,
          content: data.content
        };
      }
      agencyResource({}).then(res => {
        console.log(res);
        this.agencyList = res;
      });
      this.dialogVisible = true;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.reminderId ? editReminder : addReminder;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
          });
        }
      });
    }
  }
};